const ApiPath = {
  // 评测事件统计
  event_ai: '/v1/app/evaluation-service',

  // 获取等级列表
  hsk_level_list: '/v1/examination/levelList',
  // HSK模拟考接口数据
  hsk_paper_list: '/v1/examination/paperList',
  // HSK7||HSKK123 获取模拟考试资源
  hsk_paper_resource:'/v1/examination/levelResource',
  // 初始化试卷状态
  hsk_init_paper: '/v1/examination/initExaminationPaper',
  // 初始化试卷状态--hsk仿真作业
  hsk_init_emulation_paper: '/v1/examination/initExaminationPaperEmulation',
  // 初始化作业状态
  home_work_init_paper: '/assignment/student/initAssignmentAnswer',
  // 获取用户答题结果
  hsk_get_list_answer: '/v1/examination/listAnswer',
  // HSK模拟考保存答案
  hsk_save_result: '/v1/examination/saveAnswerMulti',
  // 作业保存答案
  home_save_result: '/assignment/student/submitAssignment',
  // HSK提交试卷
  hsk_submit_result: '/v1/examination/submitPaper',
  // 查看报告
  hsk_get_paperReport: '/v1/examination/getPaperReport',
  // HSK试卷准备页接口
  hsk_paper_repare: '/v1/examination/paperPrepare',
  // 在线评测地址
  evaluation_service: '/v1/app/evaluation-service',
  xf_evaluation_service: '/v1/app/evaluation-xfyunise-service',
  // 评测后上传音频和评测xml接口
  xf_uploadAudioBuffer: '/v1/app/uploadfile-xfyunise',
  //获取hsk主观题评测接口地址
  hsk_write_evaluation_service: '/v1/app/get-text-evaluation-url',

  //  上传文件 音频&图片&视频
  upload_file: '/common/self_set/upload_file',
  // 开放题
  get_correction_status: '/homework/get-correcting-status',

  // HSK专项训练初始化接口
  hsk_init_practise: '/v1/examination/initPartPractise',

  // HSK查询专项练习记录接口
  hsk_practise_record: '/v1/examination/getPartPractiseRecord',

  // HSK查询专项练习获取模拟考答题结果
  hsk_practise_answer: '/v1/examination/getHistoryExaminationAnswers',

  // 模拟考页简略统计接口
  hsk_mock_statistics: '/v1/examination/mockStatistics',

  // 检查用户余额是否充足
  hsk_check_Credit: '/v1/examination/checkCredit',

  // 获取在线练习
  hsk_practice_prepare: '/v1/examination/practisePrePare',

  // 模拟考结果列表查询
  hsk_mock_result_list: '/v1/examination/getMockResultList',
  // 获取等级详情
  hsk_get_level_detail: '/levelDetail',
  //获取指定等级详情-新
  get_level_detail_new: '/v1/levelDetail',
  // 模拟考证书下载
  hsk_certificate_create: '/v1/certificate/create',
  // 模拟考证书下载
  hsk_certificate_student_create: '/my_classes/certificate/create',
  // 支付相关
  pay_product_list: '/person/pay/product_list',

  // 获取当前用户货币币种
  pay_person_money_type: '/person/currency',

  // 获取货币列表
  getCurrencyList: '/person/pay/currency_list',

  //Stripe生成支付链接
  pay_payment_links: '/person/pay/stripe_payment_links',

  // Stripe 创建订单
  stripe_create_order: '/person/pay/stripe_create_order',

  // 查询订单状态
  pay_recharge_log: '/person/pay/stripe_order_status',

  // 发送partner表单
  add_partner: '/person/addPartner',

  // 试卷发布、下架、启用
  hsk_edit_paper_status: '/v1/examination/editPaperStatus',

  // 查询试卷状态
  hsk_paper_status: '/v1/examination/getPaperStatus',

  // 批改等级列表
  correct_level_list: '/v1/examination/mark/levelList',

  //批改试卷列表
  correct_mark_paper_list: '/v1/examination/mark/getMarkExaminationList',

  // 获取批改用户
  correct_mark_user: '/v1/examination/getMarkerUsers',

  // 批改初始化
  correct_mark_init: '/v1/examination/mark/initMark',

  // 查询试卷批改状态
  correct_mark_status: '/v1/examination/getMarkStatus',

  //批改提交
  correct_mark_submit: '/v1/examination/submitMark',

  // 通用
  // 获取用户所在国家
  common_fetch_user_location: '/person/location',

  // 水平测

  // 水平测获取用户信息
  get_spc_usermessage: '/v1/level/test/userInfo',
  // 获取水平测试卷
  get_spc_paper: '/v1/level/test/paper',

  // 水平测初始化接口
  init_level_test: '/level/test/initLevelTest',
  // 提交水平测作答记录
  submit_spc_result: '/v1/level/test/submit',

  // 水平测考试信息提交(new)
  submit_test_answer: '/level/test/submitTestAnswer',
  //获取等级列表接口
  get_level_list: '/v1/examination/levelList',
  //词汇
  // 获取词汇列表
  get_vocab_detail: '/word/searchWords',
  //获取字明细-writing
  get_vocab_writing: '/word/charDetail',
  //获取字明细-speaking
  get_vocab_speaking: '/word/charDetailSpeaking',
  //获取字明细-meaning
  get_vocab_meaning: '/word/charDetailMeaning',
  //字词创建
  create_word: '/word/createWord',
  //字词更新
  update_word: '/word/updateWord',
  //字词删除
  delete_word: '/word/deleteWord',
  //取消、添加收藏
  peg_word: '/word/peg',
  // 获取词汇列表下载id
  get_vocab_download_task_id: '/word/export',
  // 下载词汇列表
  vocab_download: '/open/purchase/getExportTaskStatus',

  //获取词组明细
  get_word_group_detail: '/word/wordDetail',
  //根据字查询拼音
  get_pinyin: '/word/getPinyin',
  //根据字词查询翻译
  get_translate: '/word/getTranslate',
  //获取词性枚举列表
  get_vocab_types: '/word/getWordSynTax',

  //我的
  //学习记录
  learn_history: '/v1/examination/getMockResultList',
  //赠送credit
  give_credit: '/me/present',
  //根据邮箱查询用户信息
  get_userInfo_by_email: '/me/GetUsers',
  //查看个人赠送历史记录
  give_history: '/me/getPresentHis',
  // 批量查询赠送历史
  get_batch_present_his: '/me/getBatchPresentHis',
  // 查看批量赠送详情
  get_batch_present_detail: '/me/getBatchPresentDetail',
  //查询赠送机构列表
  get_from_list: '/me/getFromList',
  // 批量赠送
  batch_give: '/me/batch/present',
  // 批量查询用户列表
  batch_search_user_list: '/me/givenUserList',
  //本人充值记录
  recharge_history: '/person/pay/recharge_logs',
  //本人消费记录
  consume_history: '/me/consumeRecord',
  //个人信息获取
  get_personal_info: '/userInfo',
  //查询指定用户消费记录
  get_someone_consume: '/me/getUserConsumeRecord',
  //查询指定用户充值记录
  get_someone_recharge: '/person/pay/person_recharge_logs',
  //修改密码
  change_passWord: '/changePassword',
  //上传头像
  change_avatar: '/person/uploadAvatar',
  //修改用户信息
  change_userInfo: '/updateUserInfo',
  //忘记密码
  forget_passWord: '/forgotPassword',

  // 查询用户是有删除权限
  search_delete_premiss: '/commonControl',

  // 检查用户注销状态
  check_user_status: '/checkDelete',

  // 删除用户
  delete_account: '/deleteAccount',

  // 取消删除用户
  cancel_delete_account: '/cancelDeleteAccount',

  // 通用
  // 查询当前语言国家
  get_country_list: '/country/dict',

  // 通知公告
  get_bulletin_board: '/person/getBulletinBoardNew',
  // 关闭公告
  hide_bulletin_board: '/person/hideBulletinBoard',

  // 我的班级教师筛选列表
  my_class_teacher_list: '/my_classes/getTeacherList',

  // 班级列表筛选
  my_class_search: '/my_classes/getClassList',

  // 学生列表
  my_class_student_list: '/my_classes/studentPaperResult',

  // 根据题号获取作答记录
  my_class_get_answer: 'v1/examination/getAnswerByQuestionId',

  // 获取试卷部分信息
  my_class_get_part: '/my_classes/studentPartResult',

  // 获取作业指定部分的作答列表
  get_home_part_answer_list: '/assignment/result/part/list',

  // 获取我的班级统计信息
  my_class_total: '/my_classes/statisticalInformation',

  // 获取学生列表试题信息
  my_class_student_result: '/my_classes/studentQuestionResult',

  // 获取学生作业列表试题信息
  assignment_paper_student_result: '/assignment/result/question/list',

  // 模考证书详情
  get_certificate_details: '/v1/certificate/check',

  // 根据订单id查询订单信息
  get_order_info: '/person/pay/get_order_info',

  // 获取通知公告消息列表
  fetch_message_list: '/person/noticeList',

  // 编辑通知公告信息
  edit_notice: '/person/editNotice',

  // 新增通知公告
  add_notice: '/person/addNotice',

  // 获取作业列表
  get_stu_assignment_list: '/assignment/student/pageList',

  // 获取作业列表（试卷列表）
  get_stu_assignment_paper_list: '/v1/examination/assignmentList',

  // 学生端查看是否存在未读作业
  search_un_read_assignment: '/assignment/unReadAssignment',

  // 赠送试卷列表
  get_paper_list_present: '/me/getPaperListForPresent',

  //国内支付创建订单
  drip_create_order: '/person/pay/drip_create_order',
  //Drip充值状态查询
  drip_order_status: '/person/pay/drip_order_status',

  //查询商品价格
  get_product_price: '/person/pay/get_product_price',
  //修改密码加密
  changePassword_enc: '/changePassword_enc',
  //作业班级列表筛选
  assignment_classList: '/assignment/getClassList',
  // 删除用户加密
  deleteAccount_enc_pwd: '/deleteAccount_enc_pwd',
  use_code: '/v1/examination/use_code',
  partnerDetail: '/v1/partner/detail',
  bannerText: '/banner_text',
  //获取当前用户所在班级信息
  getGroup: '/my_classes/getGroup',
  addSchool: '/person/addSchool',
  // 邀请码获取学校信息
  get_school_info_by_code: '/my_classes/getCampusByInviteCode',
  // 加入学校
  join_school_by_code: '/my_classes/joinCampusByInviteCode',
  // 上传录音音频
  hsk_upload_audio: '/v1/examination/upload_audio'
}
export default ApiPath
